var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon14(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1004 33.4609C37.4096 30.2699 45.4062 21.7178 45.4062 15.8795C45.4062 10.678 40.9689 6.46094 35.4955 6.46094C31.8193 6.46094 28.6168 8.36852 26.9062 11.1941C25.1957 8.36852 21.9932 6.46094 18.317 6.46094C12.8436 6.46094 8.40625 10.678 8.40625 15.8795C8.40625 20.0821 12.5503 25.6918 16.4802 29.6948",
    fill: "#E4C1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 36.2704L6.76231 34.3672L13.0381 44.5416L9.18671 46.9148",
    fill: "#FF8165"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 35.1968L7.1968 33.1016L14.1973 44.3024L9.90117 46.9149",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2016 34.5067L29.5945 34.5017C31.1395 34.5017 32.3919 33.2494 32.3919 31.7036C32.3919 30.1586 31.1395 28.9062 29.5945 28.9062L18.8921 28.9112C17.6537 28.9112 16.4371 29.2402 15.3681 29.8639L8.6084 33.8073",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2016 34.5067L29.5945 34.5017C31.1395 34.5017 32.3919 33.2494 32.3919 31.7037C32.3919 30.1586 31.1395 28.9062 29.5945 28.9062L18.8921 28.9112C17.6537 28.9112 16.4371 29.2402 15.3681 29.8639L8.6084 33.8073",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2994 34.4959L42.5363 29.1265C43.9595 28.5363 45.6053 29.2189 46.1947 30.6414C46.7842 32.0646 46.1023 33.7111 44.6798 34.3005L32.3085 40.2419C31.4454 40.6073 30.5164 40.7963 29.5783 40.7963H18.5841C17.8231 40.7963 17.0762 41.0028 16.4244 41.3941L13.9238 42.8958",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2994 34.4959L42.5363 29.1265C43.9595 28.5363 45.6053 29.2189 46.1947 30.6414C46.7842 32.0646 46.1023 33.7111 44.6798 34.3005L32.3085 40.2419C31.4454 40.6073 30.5164 40.7963 29.5783 40.7963H18.5841C17.8231 40.7963 17.0762 41.0028 16.4244 41.3941L13.9238 42.8958",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3646 33.1022C37.9303 29.5445 46.403 20.0098 46.403 13.5008C46.403 7.70154 41.7015 3 35.9022 3C32.0072 3 28.614 5.12675 26.8016 8.27698C24.9892 5.12675 21.596 3 17.7009 3C11.9017 3 7.2002 7.70154 7.2002 13.5008C7.2002 18.1862 11.5909 24.4404 15.7548 28.9033",
    stroke: "#081E54",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon14);
export default __webpack_public_path__ + "static/media/icon-14.3046898065f06ae2ff605e811448db7d.svg";
export { ForwardRef as ReactComponent };